import React from "react";
import HelpBlock from "~/common/Layout/HelpBlock";

function SupportSidebar() {
  return (
    <>
      <HelpBlock helpBlockSections={["LiveChat", "Email"]} />
      <div className="border-solid border-0 border-b border-gray-200 lt:mx-0 mx-3">
        <p className="support-label pt-3" id="FAQ-helpful-links-header">
          Helpful Links
        </p>
        <ul
          className="support-nav pb-0"
          aria-labelledby="FAQ-helpful-links-header"
        >
          <li>
            <a href="/myaccount.html?goto=register">Register for an Account</a>
          </li>
          <li>
            <a href="/shipping_time_details.html">Ground Shipping</a>
          </li>
          <li>
            <a href="/common_carrier.html">Common Carrier Shipping</a>
          </li>
          <li>
            <a href="/food-service-resources.html">Food Service Resources</a>
          </li>
          <li>
            <a href="/policies.html">Conditions of Use</a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default SupportSidebar;
